import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  topNavigation: [
    { id: "documentation", label: "Documentation" },
    { id: "api", label: "API Reference" },
  ],
  sidebar: {
    documentation: [
      {
        type: "category",
        label: "Overview",
        items: ["example", "other-example"],
      },
    ],
  },
  redirects: [{ from: "/", to: "/documentation" }],
  apis: {
    type: "url",
    input: "https://rickandmorty.zuplo.io/openapi.json", // ...or, uncomment this line to see an example
    navigationId: "api",
  },
  authentication: {
    type: "clerk",
    clerkPubKey: "pk_test_dXNhYmxlLWVlbC01OC5jbGVyay5hY2NvdW50cy5kZXYk",
  },
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
};

export default config;
